import object from 'helpers/object'


export const initialState = {
  sport: {
    status: 'anonymus',
  },
  edu: {
    status: 'anonymus',
    cashierAccessLevel: [],
  },
  rpc: {
    status: 'anonymus',
    cashierAccessLevel: [],
  },
  isFetched: false,
  // culture: [],
  // med: [],
}


export const set = (state, payload) => ({ ...state, ...payload })

export const setSport = (state, payload) => object.setIn(state, 'sport', payload)

export const setEdu = (state, payload) => object.setIn(state, 'edu', { cashierAccessLevel: [], ...state.edu, ...payload })
export const setRpc = (state, payload) => object.setIn(state, 'rpc', { cashierAccessLevel: [], ...state.rpc, ...payload })

export const setEduCashierAccessLevel = (state, payload) => object.setIn(state, 'edu.cashierAccessLevel', payload)
export const setRpcCashierAccessLevel = (state, payload) => object.setIn(state, 'rpc.cashierAccessLevel', payload)

export const setFetched = (state, payload) => object.setIn(state, 'isFetched', payload)
